/** @jsx jsx */
import { jsx } from "@emotion/react";
import { Helmet } from "react-helmet";
import { RawIntlProvider } from "react-intl";
import { ChildrenPropsType } from "src/globalTypes";
import { useLocalizationString } from "../../store/localization/useSelectors";
import staticIntl, { localeDict } from "../../utils/intl/staticIntl";

const htmlAttributes = { lang: staticIntl.locale };

const FlowioIntlProvider = ({ children }: ChildrenPropsType) => {
  const locale = useLocalizationString();

  return (
    <RawIntlProvider value={localeDict[locale]} key={locale}>
      <Helmet htmlAttributes={htmlAttributes} />
      {children}
    </RawIntlProvider>
  );
};

export default FlowioIntlProvider;
